import React from 'react'
import Typography from '@mui/material/Typography'

export const Title: React.FC = ({ children }) => (
  <Typography variant='h2' component='h1'>
    {children}
  </Typography>
)
